import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useParallaxRef } from '@/utils/parallax';

export default function SubscriptionsTab() {
  const navigate = useNavigate();
  const subtitleRef = useParallaxRef({ speed: -0.10, axis: 'y', maxTranslate: 32 });

  return (
    <>
      <CardHeader className="text-center pb-12">
        <CardTitle className="text-4xl md:text-5xl font-bold mb-6">Lease to own info</CardTitle>
        <CardDescription ref={subtitleRef as any} className="text-xl md:text-2xl text-foreground/70 mb-20">
          This section will show your active Lease-to-Own plans and recurring payments.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 pt-4">
        <div className="text-center py-12">
          <p className="text-lg font-medium text-muted-foreground mb-2">
            No active subscriptions yet
          </p>
          <p className="text-sm text-muted-foreground mb-6">
            When you have active lease-to-own plans or recurring subscriptions, they will appear here.
          </p>
          <Button variant="outline" onClick={() => navigate('/lease')}>
            Learn about Lease-to-Own
          </Button>
        </div>
      </CardContent>
    </>
  );
}

